export default __webpack_public_path__ + "static/media/INSEE-Plus-bg-on-web-reduce-size.a1fa09d9.jpg";